import React from 'react'

export const IconArrowRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="191.9 245.2 211.4 351.2"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M202.4 586c13.9 14 36.6 14 50.5 0l140-140c14-13.9 14-36.6 0-50.5l-140-140c-14.1-13.8-36.7-13.6-50.5.4-13.7 13.9-13.7 36.2 0 50.1l114.7 114.7-114.7 114.7c-14 14-14 36.6 0 50.6 0-.1 0 0 0 0z"
        fill="currentColor"
      />
    </svg>
  )
}
